<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <svg-icon src="assets/svg/child.svg"></svg-icon>
            <h1 class="page-title">{{'daycare.portaria'|translate}}</h1>
        </div>

        <p class="daycare-hint">{{'daycare.portariaexplica'|translate}}</p>

        <!-- AÇÃO PRIMEIRO: entrada ou saída (a tela muda de comportamento) -->
        <div class="daycare-mode-toggle">
            <button type="button" class="btn btn-lg"
                    [ngClass]="mode === 'entry' ? 'btn-primary text-white' : 'btn-outline-primary'"
                    [disabled]="loading" (click)="setMode('entry')">
                {{'daycare.registrarentrada'|translate}}
            </button>
            <button type="button" class="btn btn-lg ml-2"
                    [ngClass]="mode === 'exit' ? 'btn-primary text-white' : 'btn-outline-primary'"
                    [disabled]="loading" (click)="setMode('exit')">
                {{'daycare.registrarsaida'|translate}}
            </button>
            <span class="daycare-mode-current ml-3">
                {{ (mode === 'entry' ? 'daycare.modoentrada' : 'daycare.modosaida') | translate }}
            </span>
        </div>

        <!-- Campo único de busca -->
        <div class="daycare-gate-search">
            <div class="input-material flex-grow-1">
                <input #searchInput id="gateSearch" [(ngModel)]="term" (keyup.enter)="search()"
                       class="form-control" type="text" autocomplete="off" required/>
                <label for="gateSearch">
                    <svg-icon [svgClass]="'input-search'" src="assets/svg/search.svg"></svg-icon>
                    <span>{{'daycare.buscaportaria'|translate}}</span>
                </label>
            </div>
            <button type="button" class="btn btn-primary btn-lg text-white" [disabled]="loading" (click)="search()">
                {{'settings.dosearch'|translate}}
            </button>
        </div>

        <div *ngIf="loading" class="text-center my-4">{{'daycare.processando'|translate}}</div>

        <!-- Aviso de desambiguação -->
        <div *ngIf="!loading && multiplePeople" class="alert alert-warning">
            ⚠️ {{'daycare.confiranome'|translate}}
        </div>

        <!-- Resultados: uma pessoa por card -->
        <div *ngIf="!loading">
            <div class="daycare-person-card" *ngFor="let cand of candidates">
                <div class="daycare-person-head">
                    <div>
                        <span class="daycare-person-name">{{ cand.personName }}</span>
                        <span class="badge badge-primary ml-2" *ngIf="cand.personKind === 'parent'">{{'paimae'|translate}}</span>
                        <span class="badge badge-info ml-2" *ngIf="cand.personKind === 'employee'">{{'daycare.colaboradorvinculo'|translate}}</span>
                        <span class="badge badge-light ml-2" *ngIf="cand.personKind === 'authorized'">{{'daycare.autorizado'|translate}}</span>
                    </div>
                    <div class="daycare-person-doc">
                        <span *ngIf="cand.personDocument">{{ cand.personDocument }}</span>
                        <span *ngIf="!cand.personDocument" class="text-muted">{{'daycare.semdocumentocadastrado'|translate}}</span>
                    </div>
                </div>

                <div class="daycare-children">
                    <label class="daycare-child-check" *ngFor="let ch of cand.children">
                        <input type="checkbox" [(ngModel)]="ch.checked"/>
                        <span>{{ ch.name }}</span>
                        <!-- Estado atual da criança -->
                        <span class="badge badge-success ml-2" *ngIf="ch.status === 'in'">
                            {{'daycare.dentro'|translate}}
                            <ng-container *ngIf="ch.entryAt"> · {{ ch.entryAt | date:'HH:mm' }}</ng-container>
                        </span>
                        <span class="badge badge-secondary ml-2" *ngIf="ch.status !== 'in'">{{'daycare.fora'|translate}}</span>
                    </label>
                </div>

                <div class="text-right">
                    <button type="button" class="btn btn-secondary text-white" [disabled]="loading" (click)="register(cand)">
                        {{ (mode === 'entry' ? 'daycare.registrarentrada' : 'daycare.registrarsaida') | translate }}
                    </button>
                </div>
            </div>

            <!-- Nada encontrado (caso COMUM, não é erro) -->
            <div *ngIf="searched && candidates.length === 0" class="daycare-empty">
                <p>{{'daycare.nadaencontrado'|translate}}</p>
                <p class="text-muted"><small>{{'daycare.nadaencontradodica'|translate}}</small></p>
            </div>
        </div>
    </div>
</div>
